/**
 * Two days is the line, because the ping is at T-2.
 *
 * The colour and the notification have to agree: an item the app is about to
 * ask about, shown in the calm colour, makes the ping look like it came from
 * nowhere.
 */
export const SOON_DAYS = 2;
export function urgencyOf(daysLeft, status) {
    // A finished item has no urgency left — it has an outcome, and eating the
    // thing is the outcome this app exists to produce.
    if (status === "consumed")
        return "good";
    if (daysLeft === null)
        return "none";
    if (daysLeft < 0)
        return "past";
    if (daysLeft <= SOON_DAYS)
        return "soon";
    return "ok";
}
//# sourceMappingURL=urgency.js.map